import React, { useState, createContext } from 'react';
// The App component's contents are currently a placeholder — please update this file first for a new design / component!

import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Home } from './pages/Home';
import { ProductDetail } from './pages/ProductDetail';
import { Cart } from './pages/Cart';
import { Header } from './components/Header';
import { Footer } from './components/Footer';
// Define types
export type Product = {
  id: number;
  name: string;
  category: 'electronics' | 'metals';
  subcategory: string;
  price: number;
  image: string;
  description: string;
  featured?: boolean;
};
export type CartItem = {
  product: Product;
  quantity: number;
};
// Create context for cart
interface CartContextType {
  cart: CartItem[];
  addToCart: (product: Product) => void;
  removeFromCart: (productId: number) => void;
  updateQuantity: (productId: number, quantity: number) => void;
}
export const CartContext = createContext<CartContextType>({
  cart: [],
  addToCart: () => {},
  removeFromCart: () => {},
  updateQuantity: () => {}
});
export function App() {
  const [cart, setCart] = useState<CartItem[]>([]);
  const addToCart = (product: Product) => {
    setCart(prevCart => {
      const existingItem = prevCart.find(item => item.product.id === product.id);
      if (existingItem) {
        return prevCart.map(item => item.product.id === product.id ? {
          ...item,
          quantity: item.quantity + 1
        } : item);
      } else {
        return [...prevCart, {
          product,
          quantity: 1
        }];
      }
    });
  };
  const removeFromCart = (productId: number) => {
    setCart(prevCart => prevCart.filter(item => item.product.id !== productId));
  };
  const updateQuantity = (productId: number, quantity: number) => {
    if (quantity <= 0) {
      removeFromCart(productId);
      return;
    }
    setCart(prevCart => prevCart.map(item => item.product.id === productId ? {
      ...item,
      quantity
    } : item));
  };
  return <CartContext.Provider value={{
    cart,
    addToCart,
    removeFromCart,
    updateQuantity
  }} data-id="element-0">
      <BrowserRouter data-id="element-1">
        <div className="flex flex-col min-h-screen bg-gray-50" data-id="element-2">
          <Header data-id="element-3" />
          <main className="flex-grow" data-id="element-4">
            <Routes data-id="element-5">
              <Route path="/" element={<Home data-id="element-7" />} data-id="element-6" />
              <Route path="/product/:id" element={<ProductDetail data-id="element-9" />} data-id="element-8" />
              <Route path="/cart" element={<Cart data-id="element-11" />} data-id="element-10" />
            </Routes>
          </main>
          <Footer data-id="element-12" />
        </div>
      </BrowserRouter>
    </CartContext.Provider>;
}